
				var addMethods = require("../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["getCompleteDataArrayInTimeRange","getAxisMinTimestamp","getSeriesFeaturesDataForEcharts","getSeriesGroupDataForEcharts","getDatasetFeaturesDataForEcharts","getSortedFeaturesValuesByProperty","getGroupedValuesByProperty","getGroupedValuesByTimeBucket","getGroupedValuesByPropertySplitByProperty","getGroupedValuesByTimeBucketSplitByProperty"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "efe0c5d86ca3f162c529.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			